export default __webpack_public_path__ + "static/media/pattern4.97c21771.png";